import { render } from "./SpinnerElement.vue?vue&type=template&id=b6098024&scoped=true"
import script from "./SpinnerElement.vue?vue&type=script&lang=js"
export * from "./SpinnerElement.vue?vue&type=script&lang=js"

import "./SpinnerElement.vue?vue&type=style&index=0&id=b6098024&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6098024"]])

export default __exports__